import { LocaleType } from "./LocaleType";

const en: LocaleType = {
    loading: "Loading",
    about: "About",
    tutorial: "Tutorial",
    send: "Send",
    welcome: "Welcome",
    onboarding: "Onboarding",
    connected: "Connected",
    disconnected: "Disconnected",
    strange_noises: "Strange noises",

    your_nick: "Your nickname...",

    you_can_start_anew: "Start over...",
    welcome_back: "Welcome back",
    draw_something_special: "Draw a line and send it to the projection!",

    blocked_notice: "You have been permanently blocked.",
    rejected_notice: "I feel like you're drawing something inappropriate.",
    accepted_notice: "We have reviewed the image and it's fine, thanks!",

    anonymous_mode_notice: "This application does not work in anonymous mode.",
    connection_error: "Connection error",

    about_you: "About you",
    about_you_hint: "This application is anonymous, but you can tell us something about yourself if you want. For example, what your favorite color is, or what brought you here. Your information will help us understand who is using our application and how we can improve it.",

    select_color: "Select color",
    too_short_notice: "That was too short - try a longer line!",
    too_small_notice: "Draw something bigger!",

    your_drawing_was_submitted: "Your drawing was submitted and it will appear on the building soon.",
    wait_to_show_on_facade: "After that, you will be able to draw a new line here.",

    sending_image_plese_wait: "We are sending your drawing, please wait a few seconds..."
}

export default en;